import { selectors } from '~/store/state-selectors';
export const FEATURE_FEEDBACK_PROMPT_RETRY_DELAY_MS = 3000;
const FEATURE_LABELS = {
    bulkCreateProposals: 'Anchor Tax Bulk'
};
const RATING_LABELS = {
    thumbsUp: 'Thumbs up',
    thumbsDown: 'Thumbs down'
};
const NO_COMMENT = '(none)';
export const featureLeadingTexts = (bulkTexts)=>({
        bulkCreateProposals: {
            leadingText: bulkTexts.leadingText(),
            supportingText: bulkTexts.supportingText()
        }
    });
export const userToPromptFor = (state, feature)=>{
    var _state_userClientData_featureFeedbackPrompted, _state_userClientData;
    return selectors.impersonatingAs(state) == null && !((_state_userClientData = state.userClientData) === null || _state_userClientData === void 0 ? void 0 : (_state_userClientData_featureFeedbackPrompted = _state_userClientData.featureFeedbackPrompted) === null || _state_userClientData_featureFeedbackPrompted === void 0 ? void 0 : _state_userClientData_featureFeedbackPrompted[feature]) ? state.userInfo : null;
};
export function composeFeatureFeedbackText(request, submission, userInfo) {
    return [
        "Feature: ".concat(FEATURE_LABELS[request.feature]),
        "User: ".concat(userInfo.id(), " (").concat(userInfo.email(), ")"),
        "Business: ".concat(userInfo.businessId()),
        "Rating: ".concat(RATING_LABELS[submission.rating]),
        "Comment: ".concat(submission.comment === '' ? NO_COMMENT : submission.comment),
        "Context: ".concat(request.contextId)
    ].join('\n');
}
